export default __webpack_public_path__ + "static/media/manual.f6e1a099.svg";